(() => {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const lock = (on) => document.body.classList.toggle('is-locked', on);
  const store = {
    get: (k) => { try { return JSON.parse(localStorage.getItem(k)); } catch (e) { return null; } },
    set: (k, v) => { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} },
  };
  const session = {
    get: (k) => { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    set: (k, v) => { try { sessionStorage.setItem(k, v); } catch (e) {} },
  };
  const fmt = (cents) => {
    if (window.Shopify && Shopify.formatMoney && window.theme_money_format) return Shopify.formatMoney(cents, window.theme_money_format);
    return 'Rs.' + Math.round(cents / 100).toLocaleString('en-US');
  };

  /* ---------- Mosaic page transition ---------- */
  const html = document.documentElement;
  const designMode = !!(window.Shopify && Shopify.designMode);
  const endTransition = () => html.classList.remove('pt-animating');
  window.addEventListener('load', () => setTimeout(endTransition, 60));
  window.addEventListener('pageshow', (e) => { if (e.persisted) endTransition(); });

  document.addEventListener('click', (e) => {
    if (reduced || designMode || e.defaultPrevented || e.button !== 0) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    const a = e.target.closest('a[href]');
    if (!a || a.target === '_blank' || a.hasAttribute('download') || a.hasAttribute('data-no-transition')) return;
    const url = new URL(a.href, location.href);
    if (url.origin !== location.origin || !/^https?:$/.test(url.protocol)) return;
    if (url.pathname === location.pathname && url.search === location.search) return;
    if (url.pathname.startsWith('/checkout')) return;
    e.preventDefault();
    const intro = url.pathname.indexOf('/products/') !== -1 && introBlob;
    html.classList.add('pt-animating');
    if (intro) {
      // Play the logo intro on the cover (fresh blob URL restarts the GIF), fade it out, then go
      const img = $('#pt-overlay .pt-logo img');
      if (img) img.src = URL.createObjectURL(introBlob);
      html.classList.add('pt-intro');
      session.set('pt', 'intro');
      setTimeout(() => html.classList.add('pt-intro-out'), INTRO_MS - 300);
      setTimeout(() => { location.href = url.href; }, INTRO_MS);
      return;
    }
    session.set('pt', '1');
    setTimeout(() => { location.href = url.href; }, 420);
  });

  // Preload the short logo intro so it can restart instantly on product clicks
  const INTRO_MS = 3700;
  let introBlob = null;
  const introSrc = $('#pt-overlay') && $('#pt-overlay').dataset.introSrc;
  if (introSrc && !reduced && !designMode) {
    const preload = () => fetch(introSrc).then((r) => r.blob()).then((b) => { introBlob = b; }).catch(() => {});
    if ('requestIdleCallback' in window) requestIdleCallback(preload); else setTimeout(preload, 1200);
  }

  /* ---------- Header: transparent -> solid, hide on scroll down ---------- */
  const header = $('[data-header]');
  if (header) {
    let lastY = scrollY, ticking = false;
    const update = () => {
      const y = scrollY;
      header.classList.toggle('is-solid', y > 12);
      if (y > 120 && y > lastY + 4) header.classList.add('is-hidden');
      else if (y < lastY - 4 || y < 120) header.classList.remove('is-hidden');
      lastY = y; ticking = false;
    };
    addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  /* ---------- Enter page (once per visit) ---------- */
  const enter = $('[data-enter]');
  if (enter) {
    const leave = () => {
      if (enter.classList.contains('is-leaving')) return;
      enter.classList.add('is-leaving');
      session.set('entered', '1');
      html.classList.remove('enter-pending');
      setTimeout(() => { enter.hidden = true; enter.style.display = 'none'; }, 650);
    };
    $('[data-enter-open]', enter).addEventListener('click', leave);
    let y0 = null;
    enter.addEventListener('touchstart', (e) => { y0 = e.touches[0].clientY; }, { passive: true });
    enter.addEventListener('touchmove', (e) => { if (y0 !== null && y0 - e.touches[0].clientY > 50) { y0 = null; leave(); } }, { passive: true });
    enter.addEventListener('wheel', (e) => { if (e.deltaY > 20) leave(); }, { passive: true });
  }

  /* ---------- Hero scroll cue ---------- */
  const cue = $('[data-scroll-next]');
  if (cue) {
    const heroEl = cue.closest('.hero');
    cue.addEventListener('click', () => scrollTo({ top: heroEl.offsetHeight, behavior: reduced ? 'auto' : 'smooth' }));
    const toggleCue = () => cue.classList.toggle('is-hidden', scrollY > 60);
    addEventListener('scroll', toggleCue, { passive: true });
    toggleCue();
  }

  /* ---------- Mobile menu ---------- */
  const menu = $('[data-mobile-menu]');
  const burger = $('[data-open-menu]');
  const setMenu = (open) => {
    if (!menu) return;
    menu.hidden = !open;
    burger && burger.setAttribute('aria-expanded', String(open));
    lock(open);
  };
  burger && burger.addEventListener('click', () => setMenu(true));
  $$('[data-close-menu]').forEach((b) => b.addEventListener('click', () => setMenu(false)));

  /* ---------- Cart drawer ---------- */
  const drawer = $('[data-cart-drawer]');
  let lastFocus = null;
  const openCart = () => {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
    lock(true);
    const c = $('[data-close-cart]', drawer); c && c.focus();
  };
  const closeCart = () => {
    if (!drawer) return;
    drawer.hidden = true;
    drawer.setAttribute('aria-hidden', 'true');
    lock(false);
    lastFocus && lastFocus.focus && lastFocus.focus();
  };
  $$('[data-cart-toggle]').forEach((a) => a.addEventListener('click', (e) => { if (drawer) { e.preventDefault(); openCart(); } }));
  $$('[data-close-cart]').forEach((b) => b.addEventListener('click', closeCart));

  const updateShipBar = (cart) => {
    const bar = $('[data-ship-bar]');
    if (!bar) return;
    const th = Number(bar.dataset.threshold);
    const left = th - cart.total_price;
    $('[data-ship-fill]', bar).style.width = Math.min(100, (cart.total_price / th) * 100) + '%';
    bar.classList.toggle('is-complete', left <= 0);
    $('[data-ship-text]', bar).textContent = left <= 0 ? bar.dataset.msgDone : bar.dataset.msgAway.replace('__AMOUNT__', fmt(left));
  };

  const refreshCart = async () => {
    const [cart, secs] = await Promise.all([
      fetch(root + 'cart.js').then((r) => r.json()),
      fetch(root + '?sections=cart-drawer-items').then((r) => r.json()),
    ]);
    const body = $('[data-cart-body]');
    if (body && secs['cart-drawer-items']) {
      const doc = new DOMParser().parseFromString(secs['cart-drawer-items'], 'text/html');
      body.innerHTML = ($('.shopify-section', doc) || doc.body).innerHTML;
    }
    $$('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
    $$('[data-cart-count-inline]').forEach((el) => (el.textContent = `(${cart.item_count})`));
    updateShipBar(cart);
    return cart;
  };

  const flyToCart = (srcImg) => new Promise((resolve) => {
    const target = $('.header__cart');
    if (reduced || !srcImg || !target) return resolve();
    const a = srcImg.getBoundingClientRect(), b = target.getBoundingClientRect();
    const fly = srcImg.cloneNode();
    fly.removeAttribute('srcset'); fly.removeAttribute('sizes');
    Object.assign(fly.style, { position: 'fixed', left: a.left + 'px', top: a.top + 'px', width: a.width + 'px', height: a.height + 'px', objectFit: 'cover', zIndex: 9998, pointerEvents: 'none', transition: 'all 600ms cubic-bezier(.4,0,.2,1)', borderRadius: '6px' });
    document.body.appendChild(fly);
    requestAnimationFrame(() => Object.assign(fly.style, { left: b.left + b.width / 2 - 15 + 'px', top: b.top + b.height / 2 - 20 + 'px', width: '30px', height: '40px', opacity: '0.4' }));
    setTimeout(() => { fly.remove(); resolve(); }, 620);
  });

  const addToCart = async (formData, imgEl) => {
    const req = fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: formData });
    const fly = flyToCart(imgEl);
    const res = await req;
    if (!res.ok) { const err = await res.json().catch(() => ({})); throw new Error(err.description || err.message || 'Could not add'); }
    await fly;
    openCart();
    await refreshCart();
  };

  const changeLine = async (line, quantity) => {
    await fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line, quantity }) });
    await refreshCart();
  };

  document.addEventListener('click', async (e) => {
    const t = e.target.closest('button');
    if (!t) return;
    if (t.dataset.qty) {
      const span = t.parentElement.querySelector('span');
      changeLine(Number(t.dataset.line), Math.max(0, Number(span.textContent) + Number(t.dataset.qty)));
    } else if (t.dataset.removeLine) {
      changeLine(Number(t.dataset.removeLine), 0);
    } else if (t.dataset.quickAdd) {
      t.classList.add('is-loading');
      const fd = new FormData(); fd.append('id', t.dataset.quickAdd); fd.append('quantity', 1);
      try { await addToCart(fd); } catch (err) { alert(err.message); } finally { t.classList.remove('is-loading'); }
    }
  });

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-ajax-add], [data-pdp-form]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type=submit]') || $('[data-atc-sticky]');
    btn && btn.classList.add('is-loading');
    const img = form.closest('[data-product-card]') ? $('.product-card__slide img', form.closest('[data-product-card]')) : ($('.pdp__slide.is-active img') || $('.pdp__slide img'));
    try { await addToCart(new FormData(form), img); } catch (err) { alert(err.message); }
    btn && btn.classList.remove('is-loading');
  });

  /* ---------- Modals (size guide + popup links) ---------- */
  const openModal = (m) => { if (m) { m.hidden = false; lock(true); } };
  const closeModals = () => { $$('.modal').forEach((m) => (m.hidden = true)); lock(false); };
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-open-size-guide]')) openModal($('[data-size-modal]'));
    const p = e.target.closest('[data-open-popup]');
    if (p) openModal(document.getElementById(p.dataset.openPopup));
    if (e.target.closest('[data-close-modal]')) closeModals();
  });

  /* ---------- Search modal ---------- */
  const sm = $('[data-search-modal]');
  if (sm) {
    const input = $('[data-search-input]', sm);
    const emptyEl = $('[data-search-empty]', sm), resEl = $('[data-search-results]', sm);
    const list = $('[data-search-list]', sm), none = $('[data-search-none]', sm), all = $('[data-search-all]', sm);
    const recWrap = $('[data-recent-wrap]', sm), recList = $('[data-recent-list]', sm);
    const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    const item = (p) => `<li><a href="${esc(p.url)}" class="smodal__item">${p.image ? `<img src="${esc(p.image)}" width="56" height="72" alt="">` : '<span></span>'}<span class="smodal__name">${esc(p.title)}</span><span class="smodal__price">${esc(p.price || '')}</span></a></li>`;
    const openSearch = () => {
      const rv = store.get('rv') || [];
      recWrap.hidden = rv.length === 0;
      recList.innerHTML = rv.slice(0, 4).map(item).join('');
      sm.hidden = false; lock(true);
      setTimeout(() => input.focus(), 30);
    };
    const closeSearch = () => { sm.hidden = true; lock(false); };
    $$('[data-open-search]').forEach((b) => b.addEventListener('click', openSearch));
    $$('[data-close-search]', sm).forEach((b) => b.addEventListener('click', closeSearch));
    let timer, ctrl;
    input.addEventListener('input', () => {
      clearTimeout(timer);
      const q = input.value.trim();
      if (!q) { emptyEl.hidden = false; resEl.hidden = true; return; }
      timer = setTimeout(async () => {
        ctrl && ctrl.abort(); ctrl = new AbortController();
        try {
          const r = await fetch(`${root}search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`, { signal: ctrl.signal });
          const prods = ((await r.json()).resources.results.products) || [];
          list.innerHTML = prods.map((p) => item({ url: p.url, title: p.title, image: p.image, price: fmt(parseFloat(p.price) * 100) })).join('');
          none.hidden = prods.length > 0; all.hidden = prods.length === 0;
          all.href = `${root}search?q=${encodeURIComponent(q)}&type=product`;
          emptyEl.hidden = true; resEl.hidden = false;
        } catch (err) { /* aborted */ }
      }, 200);
    });
  }

  /* ---------- Global Escape ---------- */
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    if (drawer && !drawer.hidden) closeCart();
    if (menu && !menu.hidden) setMenu(false);
    if (sm && !sm.hidden) { sm.hidden = true; lock(false); }
    closeModals();
  });

  /* ---------- Product card arrows ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-card-prev], [data-card-next]');
    if (!b) return;
    e.preventDefault();
    const s = $('[data-card-slides]', b.closest('[data-product-card]'));
    s.scrollBy({ left: (b.hasAttribute('data-card-next') ? 1 : -1) * s.clientWidth, behavior: 'smooth' });
  });

  /* ---------- Product page ---------- */
  const initPdp = (pdp) => {
    const rvItem = { title: pdp.dataset.rvTitle, url: pdp.dataset.rvUrl, image: pdp.dataset.rvImage, price: pdp.dataset.rvPrice };
    store.set('rv', [rvItem].concat((store.get('rv') || []).filter((p) => p.url !== rvItem.url)).slice(0, 8));

    const variants = JSON.parse($('[data-variants]', pdp).textContent);
    const form = $('[data-pdp-form]', pdp);
    const idInput = $('[data-variant-id]', pdp);
    const labels = $$('[data-atc-label]', pdp);
    const atcBtns = [$('[data-atc]', pdp), $('[data-atc-sticky]', pdp)].concat($$('[data-buy-now]', pdp)).filter(Boolean);
    const selected = () => $$('.opt__input:checked', pdp).sort((a, b) => a.dataset.optionIndex - b.dataset.optionIndex).map((i) => i.value);
    const findVariant = (vals) => variants.find((v) => vals.every((val, i) => v.options[i] === val));
    const labelAdd = labels[0] ? labels[0].textContent : 'Add to cart';

    const markUnavailable = () => {
      const sel = selected();
      $$('.opt__input', pdp).forEach((inp) => {
        const test = sel.slice(); test[Number(inp.dataset.optionIndex)] = inp.value;
        const v = findVariant(test);
        inp.classList.toggle('is-unavailable', !v || !v.available);
      });
    };
    const apply = () => {
      const sel = selected();
      const v = findVariant(sel);
      markUnavailable();
      $$('.opt__input:checked', pdp).forEach((i) => { const el = $('[data-opt-selected]', i.closest('fieldset')); if (el) el.textContent = i.value; });
      if (!v) { labels.forEach((l) => (l.textContent = 'Unavailable')); atcBtns.forEach((b) => (b.disabled = true)); return; }
      idInput.value = v.id;
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
      const wa = $('.pdp__wa', pdp);
      if (wa) wa.href = `${wa.dataset.waBase}?text=` + encodeURIComponent(`Hi! I want to order: ${wa.dataset.waProduct} (${sel.join(' / ')}) ${wa.dataset.waUrl}?variant=${v.id}`);
      $('[data-price-current]', pdp).textContent = fmt(v.price);
      const cmp = $('[data-price-compare]', pdp);
      const onSale = v.compare_at_price && v.compare_at_price > v.price;
      cmp.hidden = !onSale; if (onSale) cmp.textContent = fmt(v.compare_at_price);
      $('[data-price]', pdp).classList.toggle('price--on-sale', !!onSale);
      $$('[data-discount-badge]', pdp).forEach((badge) => { badge.hidden = !onSale; if (onSale) badge.textContent = '-' + Math.round(((v.compare_at_price - v.price) * 100) / v.compare_at_price) + '%'; });
      $$('[data-sticky-price] .price__current', pdp).forEach((el) => (el.textContent = fmt(v.price)));
      labels.forEach((l) => (l.textContent = v.available ? labelAdd : 'Sold out'));
      atcBtns.forEach((b) => (b.disabled = !v.available));
    };
    $$('.opt__input', pdp).forEach((i) => i.addEventListener('change', apply));
    markUnavailable();

    const sticky = $('[data-sticky-atc]', pdp), mainBtn = $('[data-atc]', pdp);
    if (sticky && mainBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => {
        const show = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', String(!show));
      }).observe(mainBtn);
    }

    /* Wide layout: keep the buy and Overview cards the same height */
    const cardA = $('.pdp__buy', pdp), cardB = $('.pdp__overview', pdp), wideMq = matchMedia('(min-width: 1200px)');
    const equalise = () => {
      pdp.style.removeProperty('--card-h');
      if (!cardA || !cardB || !wideMq.matches) return;
      pdp.style.setProperty('--card-h', Math.max(cardA.offsetHeight, cardB.offsetHeight) + 'px');
    };
    equalise();
    addEventListener('resize', equalise);
    addEventListener('load', equalise);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(equalise);
    $$('.opt__input', pdp).forEach((i) => i.addEventListener('change', () => requestAnimationFrame(equalise)));
    if (cardB) cardB.addEventListener('toggle', equalise);

    /* Gallery: one photo at a time; thumbnail tap, swipe or wheel steps through, page scrolls on at the ends */
    const stage = $('[data-stage]', pdp), slides = $$('.pdp__slide', pdp), thumbs = $$('.pdp__thumb', pdp);
    if (stage && slides.length > 1) {
      let cur = 0, lastStep = 0, lastWheel = 0;
      const list = $('[data-thumbs]', pdp);
      const show = (i) => {
        cur = i;
        slides.forEach((sl, n) => sl.classList.toggle('is-active', n === i));
        thumbs.forEach((t, n) => { t.classList.toggle('is-active', n === i); t.setAttribute('aria-current', String(n === i)); });
        if (list && thumbs[i]) {
          const row = getComputedStyle(list).flexDirection === 'row';
          const t = thumbs[i];
          list.scrollTo(row ? { left: t.offsetLeft - list.clientWidth / 2 + t.offsetWidth / 2, behavior: 'smooth' } : { top: t.offsetTop - list.clientHeight / 2 + t.offsetHeight / 2, behavior: 'smooth' });
        }
      };
      const step = (dir) => {
        const n = cur + dir;
        if (n < 0 || n >= slides.length) return false;
        show(n); lastStep = Date.now(); return true;
      };
      stage.addEventListener('wheel', (e) => {
        if (Math.abs(e.deltaY) < Math.abs(e.deltaX) || !e.deltaY) return;
        const dir = e.deltaY > 0 ? 1 : -1;
        const n = cur + dir;
        if (n < 0 || n >= slides.length) return; /* at the ends: let the page scroll */
        e.preventDefault();
        const now = Date.now(), gap = now - lastWheel; lastWheel = now;
        if ((gap > 120 || now - lastStep > 500) && now - lastStep > 350) step(dir);
      }, { passive: false });
      let tx = 0, ty = 0;
      stage.addEventListener('touchstart', (e) => { tx = e.touches[0].clientX; ty = e.touches[0].clientY; }, { passive: true });
      stage.addEventListener('touchend', (e) => {
        const dx = e.changedTouches[0].clientX - tx, dy = e.changedTouches[0].clientY - ty;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) step(dx < 0 ? 1 : -1);
      }, { passive: true });
      thumbs.forEach((t, n) => t.addEventListener('click', () => show(n)));
    }
  };

  window.clobberInitPdp = initPdp;
  const pdp0 = $('[data-product-form-root]');
  if (pdp0) initPdp(pdp0);

  /* ---------- Recommendations ---------- */
  const recs = $('[data-recs]');
  if (recs && recs.dataset.url) {
    fetch(recs.dataset.url).then((r) => r.text()).then((t) => {
      const doc = new DOMParser().parseFromString(t, 'text/html');
      const next = $('[data-recs]', doc);
      if (next && next.innerHTML.trim()) recs.innerHTML = next.innerHTML;
    }).catch(() => {});
  }

  /* ---------- Collection: popovers, auto-submit, grid size ---------- */
  const fw = $('[data-filter-wrap]');
  const ft = $('[data-toggle-filters]');
  if (fw && ft) ft.addEventListener('click', () => { const o = fw.classList.toggle('is-open'); ft.setAttribute('aria-expanded', String(o)); });
  const drops = $$('[data-drop]');
  document.addEventListener('click', (e) => {
    drops.forEach((d) => { if (d.open && !d.contains(e.target)) d.open = false; });
  });
  drops.forEach((d) => d.addEventListener('toggle', () => { if (d.open) drops.forEach((o) => { if (o !== d) o.open = false; }); }));
  $$('[data-auto-submit]').forEach((el) => el.addEventListener('change', () => el.form && el.form.submit()));

  const grid = $('[data-product-grid]');
  const sizeBtns = $$('[data-grid-size]');
  if (grid && sizeBtns.length) {
    const mobile = matchMedia('(max-width: 749px)');
    const apply = (size) => {
      const def = mobile.matches ? 'medium' : 'large';
      const cur = size || def;
      if (size) grid.dataset.size = size; else delete grid.dataset.size;
      sizeBtns.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.gridSize === cur)));
    };
    apply(session.get('gridSize'));
    sizeBtns.forEach((b) => b.addEventListener('click', () => { session.set('gridSize', b.dataset.gridSize); apply(b.dataset.gridSize); }));
  }
})();

/* ---------- Product 360 view / gallery toggle (also mounted from the home wall) ---------- */
  (() => {
    const clamp = (v, a = 0, b = 1) => Math.min(b, Math.max(a, v));
    const init = (track) => {
      if (track.dataset.ready) return;
      track.dataset.ready = '1';
      const root = track.dataset.root;
      const pdp = track.querySelector('.pdp');
      const media = track.querySelector('.pdp__media');
      const pin = track.querySelector('.pdp__pin');
      const video = track.querySelector('[data-v360-video]');
      const btns = [...track.querySelectorAll('[data-mode-btn]')];
      const bar = track.querySelector('[data-v360-bar]');
      const hint = track.querySelector('[data-v360-hint]');
      const play = track.querySelector('[data-v360-play]');
      const wide = matchMedia('(min-width: 1200px)');
      let target = 0, cur = 0, raf = 0, auto = false;

      const render = () => {
        if (bar) bar.style.transform = 'scaleX(' + cur.toFixed(4) + ')';
        if (hint) hint.style.opacity = cur > 0.03 ? '0' : '';
        if (!video || auto || !video.duration) return;
        const t = cur * Math.max(0, video.duration - 0.04);
        if (!video.seeking && Math.abs(video.currentTime - t) > 0.012) video.currentTime = t;
      };
      const readTarget = () => {
        if (track.dataset.mode !== '360') return;
        let p;
        if (wide.matches) {
          const pad = parseFloat(getComputedStyle(track).paddingTop) || 0;
          const total = Math.max(1, track.offsetHeight - pad - pdp.offsetHeight);
          const stick = parseFloat(getComputedStyle(pdp).top) || 0;
          p = (stick - (track.getBoundingClientRect().top + pad)) / total;
        } else {
          const total = Math.max(1, media.offsetHeight - pin.offsetHeight);
          p = ((parseFloat(getComputedStyle(pin).top) || 0) - media.getBoundingClientRect().top) / total;
        }
        target = clamp(p);
      };
      const tick = () => {
        raf = 0;
        cur += (target - cur) * 0.16;
        if (Math.abs(target - cur) < 0.0004) cur = target;
        render();
        if (cur !== target) raf = requestAnimationFrame(tick);
      };
      const kick = () => {
        readTarget();
        if (auto && Math.abs(target - cur) > 0.0015) takeOver();
        if (!raf) raf = requestAnimationFrame(tick);
      };
      /* first scroll or swipe ends the self-playing intro; the spin glides to where the scroll is */
      const takeOver = () => {
        const f = video && video.duration ? video.currentTime / video.duration : 0;
        auto = false;
        video.loop = false; video.pause();
        if (play) play.setAttribute('aria-pressed', 'false');
        cur = clamp(f);
      };

      /* Page colour around the video: matched to the video's edge colour, or a custom colour */
      const setBg = (c) => document.documentElement.style.setProperty('--pdp-bg', c || '');
      const bgMode = track.dataset.bg;
      let bgColor = '';
      const applyBg = () => {
        const on = track.dataset.mode === '360' && bgColor;
        setBg(on ? bgColor : '');
        track.toggleAttribute('data-bg-on', !!on && bgMode === 'match');
      };
      if (video && bgMode === 'custom' && track.dataset.bgColor) { bgColor = track.dataset.bgColor; applyBg(); }
      else if (video && bgMode === 'match' && track.dataset.poster) {
        const im = new Image();
        im.crossOrigin = 'anonymous';
        im.onload = () => {
          try {
            const c = document.createElement('canvas'); c.width = 24; c.height = 40;
            const x = c.getContext('2d'); x.drawImage(im, 0, 0, 24, 40);
            let r = 0, g = 0, b = 0, n = 0;
            for (let i = 0; i < 24; i++) for (let j = 0; j < 40; j++) {
              if (i > 2 && i < 21 && j > 2 && j < 37) continue;
              const d = x.getImageData(i, j, 1, 1).data; r += d[0]; g += d[1]; b += d[2]; n++;
            }
            bgColor = 'rgb(' + Math.round(r / n) + ',' + Math.round(g / n) + ',' + Math.round(b / n) + ')';
            applyBg();
          } catch (e) { /* tainted canvas: keep grey */ }
        };
        im.src = track.dataset.poster;
      }

      const setAuto = (on) => {
        auto = on;
        if (!video) return;
        play.setAttribute('aria-pressed', String(on));
        video.loop = on;
        if (on) { const r = video.play(); if (r && r.catch) r.catch(() => setAuto(false)); }
        else { video.pause(); render(); }
        render();
      };
      const setMode = (m) => {
        if (track.dataset.mode === m) return;
        const above = track.getBoundingClientRect().top < 0;
        track.dataset.mode = m;
        btns.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.modeBtn === m)));
        if (m !== '360') setAuto(false);
        applyBg();
        if (above) {
          const sc = track.closest('.sg__pdp');
          if (sc) sc.scrollTop += track.getBoundingClientRect().top;
          else scrollTo({ top: scrollY + track.getBoundingClientRect().top, behavior: 'instant' });
        }
        kick();
      };
      btns.forEach((b) => b.addEventListener('click', () => setMode(b.dataset.modeBtn)));
      if (play) play.addEventListener('click', () => setAuto(!auto));
      const embed = !!track.closest('.sg__pdp');
      const startAuto = () => {
        if (!video || track.dataset.autoplay !== 'true' || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        if (track.dataset.mode !== '360' || auto || cur > 0.01 || target > 0.01) return;
        setAuto(true);
      };
      if (video) {
        video.addEventListener('timeupdate', () => { if (auto && bar && video.duration) bar.style.transform = 'scaleX(' + (video.currentTime / video.duration).toFixed(4) + ')'; });
        if (!embed) video.addEventListener('canplay', startAuto, { once: true });
        else addEventListener('pdp-landed', startAuto);
        video.addEventListener('loadedmetadata', render);
        video.addEventListener('seeked', render);
        video.load();
      }
      addEventListener('scroll', kick, { passive: true, capture: true });
      addEventListener('resize', kick);
      addEventListener('load', kick);

      track.querySelectorAll('[data-buy-now]').forEach((btn) => btn.addEventListener('click', async () => {
        const form = track.querySelector('[data-pdp-form]');
        if (!form || btn.disabled) return;
        btn.classList.add('is-loading');
        try {
          const r = await fetch(root + 'cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
          const j = await r.json();
          if (!r.ok) throw new Error(j.description || j.message || 'Could not add this item');
          (window.top || window).location.href = root + 'checkout';
        } catch (err) { alert(err.message); btn.classList.remove('is-loading'); }
      }));
      kick();

    };
    const boot = () => document.querySelectorAll('[data-pdp-track]').forEach(init);
    window.clobberInitTracks = boot;
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

/* ---------- First frame of a product video, backdrop removed (wall + gallery) ---------- */
(() => {
    /* Takes a video's first frame and removes the plain studio backdrop: flood-fill from the edges, then soften the cut */
    window.clobberCutOut = (url) => new Promise((resolve, reject) => {
      const im = new Image();
      im.crossOrigin = 'anonymous';
      im.onerror = () => reject(new Error('load'));
      im.onload = () => {
        try {
          const W = 540, H = Math.round(W * im.naturalHeight / im.naturalWidth);
          const c = document.createElement('canvas'); c.width = W; c.height = H;
          const x = c.getContext('2d', { willReadFrequently: true });
          x.drawImage(im, 0, 0, W, H);
          const d = x.getImageData(0, 0, W, H), p = d.data, n = W * H;
          let r = 0, g = 0, b = 0, k = 0;
          const ring = (i) => { r += p[i * 4]; g += p[i * 4 + 1]; b += p[i * 4 + 2]; k++; };
          for (let i = 0; i < W * 6; i++) ring(i);
          for (let y = 0; y < H; y += 2) for (let t = 0; t < 4; t++) { ring(y * W + t); ring(y * W + W - 1 - t); }
          r /= k; g /= k; b /= k;
          const near = (i) => {
            const R = p[i * 4], G = p[i * 4 + 1], B = p[i * 4 + 2];
            if (Math.max(R, G, B) - Math.min(R, G, B) > 16) return false; // backdrop is neutral grey; skin, colours are not
            const dr = R - r, dg = G - g, db = B - b; return dr * dr + dg * dg + db * db < 58 * 58;
          };
          const step = (i, j) => { const dr = p[i * 4] - p[j * 4], dg = p[i * 4 + 1] - p[j * 4 + 1], db = p[i * 4 + 2] - p[j * 4 + 2]; return dr * dr + dg * dg + db * db < 9 * 9; };
          const bg = new Uint8Array(n), q = new Int32Array(n); let qh = 0, qt = 0;
          const seed = (i) => { if (!bg[i] && near(i)) { bg[i] = 1; q[qt++] = i; } };
          for (let i = 0; i < W; i++) { seed(i); seed((H - 1) * W + i); }
          for (let y = 0; y < H; y++) { seed(y * W); seed(y * W + W - 1); }
          while (qh < qt) {
            const i = q[qh++], px = i % W;
            const nb = [px > 0 ? i - 1 : -1, px < W - 1 ? i + 1 : -1, i >= W ? i - W : -1, i < n - W ? i + W : -1];
            for (let m = 0; m < 4; m++) { const j = nb[m]; if (j >= 0 && !bg[j] && near(j) && step(i, j)) { bg[j] = 1; q[qt++] = j; } }
          }
          // keep only the biggest subject blob (drops specks and the video's corner sparkle)
          const lab = new Int32Array(n); let best = 0, bestId = 0, id = 0;
          for (let st = 0; st < n; st++) {
            if (bg[st] || lab[st]) continue;
            id++; let h = 0, t = 0; q[t++] = st; lab[st] = id;
            while (h < t) {
              const i = q[h++], px = i % W;
              const nb = [px > 0 ? i - 1 : -1, px < W - 1 ? i + 1 : -1, i >= W ? i - W : -1, i < n - W ? i + W : -1];
              for (let m = 0; m < 4; m++) { const j = nb[m]; if (j >= 0 && !bg[j] && !lab[j]) { lab[j] = id; q[t++] = j; } }
            }
            if (t > best) { best = t; bestId = id; }
          }
          for (let i = 0; i < n; i++) if (!bg[i] && lab[i] !== bestId) bg[i] = 1;
          // alpha: subject = 255; erode one pixel, then blur one pixel so the edge is soft and has no halo
          const a1 = new Float32Array(n);
          for (let i = 0; i < n; i++) a1[i] = bg[i] ? 0 : 1;
          const er = new Float32Array(n);
          for (let y = 0; y < H; y++) for (let xx = 0; xx < W; xx++) {
            const i = y * W + xx; let v = a1[i];
            if (xx > 0) v = Math.min(v, a1[i - 1]); if (xx < W - 1) v = Math.min(v, a1[i + 1]);
            if (y > 0) v = Math.min(v, a1[i - W]); if (y < H - 1) v = Math.min(v, a1[i + W]);
            er[i] = v;
          }
          for (let y = 0; y < H; y++) for (let xx = 0; xx < W; xx++) {
            const i = y * W + xx; let s = er[i] * 4, w = 4;
            if (xx > 0) { s += er[i - 1] * 2; w += 2; } if (xx < W - 1) { s += er[i + 1] * 2; w += 2; }
            if (y > 0) { s += er[i - W] * 2; w += 2; } if (y < H - 1) { s += er[i + W] * 2; w += 2; }
            p[i * 4 + 3] = Math.round(255 * s / w);
          }
          x.putImageData(d, 0, 0);
          c.toBlob((blob) => blob ? resolve(URL.createObjectURL(blob)) : reject(new Error('blob')), 'image/png');
        } catch (e) { reject(e); }
      };
      im.src = url;
    });
  const fill = () => document.querySelectorAll('.pdp [data-cut]').forEach((im) => {
    if (im.dataset.cutDone) return; im.dataset.cutDone = '1';
    window.clobberCutOut(im.dataset.cut).then((u) => { im.src = u; }).catch(() => { im.src = im.dataset.fallback; });
  });
  window.clobberFillCuts = fill;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fill); else fill();
})();
